import React, { useState,useRef } from "react";
import {
    AppBar,
    Toolbar,
    List,
    ListItem,
    ListItemText,
    Collapse,
    Button,
    Box,
    Drawer,
    IconButton,
        Tooltip,
    Dialog, DialogContent,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import { useAuth, useNavigation, useLoading } from "../Context/Contexts";
import { useLocation } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import SettingsNavigationBar from "./SettingsNavigationBar";
import ReportNavigationBar from "./ReportNavigationBar";
import CompanyNavigationBar from "./CompanyNavigationBar";
import { useTranslation } from "react-i18next";
import SearchIcon from '@mui/icons-material/Search';
import SearchComponent from "./Search/SearchComponent";
import HelpCenterIcon from '@mui/icons-material/HelpCenter';


const MenuItem = ({ config, closeMenu }: { config: any; closeMenu: () => void }) => {
    const { navigate } = useNavigation();

    const navigateTo = (path: string, params?: { [key: string]: any }) => {
        navigate({ path, params: params });
        closeMenu(); // Close the drawer after navigating
    };

    return (
        <ListItem
            button
            href={`${config.to}${config.params ? "?" + new URLSearchParams(config.params).toString() : ""}`}
            component="a"
            sx={{
                padding: "8px 16px",
                "&:hover": { backgroundColor: "primary.light" },
                color: "white",
            }}
        >
            <ListItemText primary={config.title} />
        </ListItem>
    );
};

const ExpandableMenuItem = ({
    config,
    closeMenu,
    openMenus,
    setOpenMenus,
}: {
    config: any;
    closeMenu: () => void;
    openMenus: { [key: string]: boolean };
    setOpenMenus: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
}) => {
    const location = useLocation();
    let currentPath = location.pathname.toLowerCase();
    const basePath = currentPath.split("/").slice(0, -1).join("/");

    const shouldExpand = basePath.length > 0 &&   config.items?.some((item: any) => item.to && (item.to.startsWith(basePath) || currentPath === item.to) );

    const isOpen = openMenus[config.area] ?? shouldExpand;

    const handleClick = () => {
        setOpenMenus((prevState) => ({
            ...prevState,
            [config.area]: !isOpen, // Toggle the current menu
        }));
    };

    return (
        <Box>
            <ListItem
                button
                onClick={handleClick}
                sx={{
                    padding: "8px 16px",
                    color: "white",
                    "&:hover": { backgroundColor: "primary.light" },
                }}
            >
                <ListItemText primary={config.title} />
                {isOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List disablePadding sx={{ pl: 4 }}>
                    {config.items.map((item: any) =>
                        item.items ? (
                            <ExpandableMenuItem
                                key={item.title}
                                config={item}
                                closeMenu={closeMenu}
                                openMenus={openMenus} // Pass openMenus state
                                setOpenMenus={setOpenMenus} // Pass setOpenMenus function
                            />
                        ) : (
                            <MenuItem
                                key={item.title}
                                config={item}
                                closeMenu={closeMenu}
                            />
                        )
                    )}
                </List>
            </Collapse>
        </Box>
    );
};

const NavigationDrawer = ({
    items,
    closeMenu,
}: {
    items: any[];
    closeMenu: () => void;
}) => {
    const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

    return (
        <List>
            {items.map((menuItem) =>
                menuItem.items ? (
                    <ExpandableMenuItem
                        key={menuItem.title}
                        config={menuItem}
                        closeMenu={closeMenu}
                        openMenus={openMenus} // Pass openMenus state
                        setOpenMenus={setOpenMenus} // Pass setOpenMenus function
                    />
                ) : (
                    <MenuItem
                        key={menuItem.title}
                        config={menuItem}
                        closeMenu={closeMenu}
                    />
                )
            )}
        </List>
    );
};

const NavigationBar: React.FC = () => {
    const { isAuthenticated, authService, setIsAuthenticated } = useAuth();
    const { navigate } = useNavigation();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { t } = useTranslation();
    const [showSearch, setShowSearch] = useState(false)
    const handleLogout = async () => {
        try {
            await authService.logout();
            setIsAuthenticated(false);
        } catch (error) {
            console.error("Failed to logout:", error);
        }
    };

    const navigateTo = (path: string, params?: { [key: string]: any }) => {
        navigate({ path, params });
    };

    type SettingsItem = {
  title: string;
  to: string;
  disabled?: boolean;
  params?: { [key: string]: any };
};

type SettingsSection = {
  title: string;
  items: SettingsItem[];
};
    const menu = [
        {
            title: t("common.sales"), area: "sales",
            items: [
                { title: t("common.order"), to: "/sales/order/list" },
                { title: t("common.customers"), to: "/sales/customer/list" },
                { title: t("common.returns"), to: "/sales/return/list" ,params: { open: true } },
                { title: t("common.certificates"), to: "/sales/cardvoucher/list" },
           /*     { title: t("common.bonusBatch"), to: "/sales/bonus/batch" },*/
                { title: t("common.pricelist"), to: "/sales/pricelist/list" },
        
   /*             { title: "Create return list bugaloo", to: "/sales/return/candidates" },*/
                {
                    title: t("common.history"), area: "salesHistory", items: [
                        { title: t("common.shipment"), to: "/sales/shipment/list" },
                        { title: t("common.order"), to: "/sales/history/documentlist", params: { documentType: 1 } },
                        { title: t("common.invoice"), to: "/sales/history/documentlist", params: { documentType: 2 } },
                        { title: t("common.credit"), to: "/sales/history/documentlist", params: { documentType: 3 } },
                        { title: t("common.returns"), to: "/sales/return/list", params: { open: false } },
                    ]
                }
            ],
        },
        //{
        //    title: t("common.purchase"), area: "purchase",
        //    items: [

        //        //{
        //        //    title: t("common.settings"), area: "purchaseSettings", items: [
        //        //        {
        //        //            title: t("common.itemDimensions"), area: "purchaseItemSettings", items: [
        //        //                { title: t("common.colourGroup"), to: "/purchase/item/colourgroup/list" },
        //        //                { title: t("common.sizeGroup"), to: "/purchase/item/sizegroup/list" },
        //        //                { title: t("common.lengthGroup"), to: "/purchase/item/lengthgroup/list" }
        //        //            ]
        //        //        },
        //        //        { title: t("common.itemGroup"), to: "/purchase/settings/itemgroup" },
        //        //        { title: t("common.itemCategory"), to: "/purchase/settings/itemcategory" },
        //        //        { title: t("common.productGroup"), to: "/purchase/settings/productgroup" },
        //        //        { title: t("common.program"), to: "/purchase/settings/program" },
        //        //        { title: t("common.collection"), to: "/purchase/settings/collection" }
        //        //    ]
        //        //}
        //    ],
        //},
        {
            title: t("common.inventory"), area: "Inventory",
            items: [
                { title: t("common.items"), to: "/purchase/item/list" },
                //{ title: t("common.batches"), to: "/warehouse/batch/list" },
                { title: t("common.transactions"), to: "/inventory/itemledger/transactions" },
                { title: t("common.suppliers"), to: "/purchase/supplier/list" },

                { title: t("common.invAdjustment"), to: "/inventory/journal/list", params: { open: true } },
                {
                    title: t("common.history"), area: "inventoryHistory", items: [
                        { title: t("common.invAdjustment"), to: "/inventory/journal/list", params: { open: false } }
                    ]
                }
            ],
        },
        //{
        //    title: "Settings", area: "settings",
        //    items: [
        //        { title: "Account", to: "/settings/account/list" },
        //        { title: "Currency", to: "/settings/currency/list" },
        //        { title: "Country", to: "/settings/country/list" },
        //        { title: "Company", to: "/settings/company/list" },
        //        { title: "Language", to: "/settings/language/list" },
        //        { title: "Location", to: "/settings/location/list" },
        //        { title: "Payment Terminal", to: "/settings/paymentterminal/list" },
        //        { title: "Posting Setup", to: "/settings/postingsetup/list" },
        //        { title: "Printer", to: "/settings/printer/list" },
        //        { title: "Salesperson", to: "/settings/salesperson/list" },
        //        { title: "Shipping Agent", to: "/settings/shippingagent/list" },
        //        { title: "Shop", to: "/sp/list" },
        //        { title: "Terminal", to: "/settings/terminal/list" },
        //    ],
        //},
        //{
        //    title: "Administration",area:"admin",
        //    items: [
        //        { title: "Metrics", to: "/admin/metrics/view" },
        //        { title: "Users", to: "/admin/user/list" },
        //    ],
        //},
    ];

    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: "primary.dark",
                color: "white",
                padding: { xs: "2px", sm: "16px" },
            }}
        >

            <Toolbar
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: { xs: "0 5px", sm: "0 16px" },
                }}
            >
                {isAuthenticated && (
                    <IconButton
                        color="inherit"
                        onClick={() => setDrawerOpen(true)}
                    >
                        <MenuIcon />
                    </IconButton>
                )}

      
                {isAuthenticated && (
                    <>
                        <Dialog
                            open={showSearch}
                            onClose={() => setShowSearch(false)}
                            fullWidth
                            maxWidth="md"
                        >
                            <DialogContent>
                                <SearchComponent />
                            </DialogContent>
                        </Dialog>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: { xs: 0.1, sm: 2 }, 
                            marginLeft: { xs: 0.1, sm: "1em" },
                            color: "red",
                        }}>
                            <Tooltip title={t("common.home")}>
                                <IconButton onClick={() => navigateTo("/home")} color="secondary">
                                    <HomeIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={t("common.help")}>
                                <IconButton
                                    onClick={() => window.open("https://perfectit.document360.io/docs/v%C3%A4lkommen-till-minibackoffice", "_blank")}
                                    color="secondary"
                                >
                                    <HelpCenterIcon />
                                </IconButton>
                            </Tooltip>
                  

                            <SettingsNavigationBar />
                            <CompanyNavigationBar />
                            <ReportNavigationBar />
                            <Tooltip title={t("common.search")}>
                                <IconButton onClick={() => setShowSearch(true)} color="secondary">
                                    <SearchIcon />
                                </IconButton>
                            </Tooltip>
                
                    <Button
                        variant="text"
                        onClick={handleLogout}
                        sx={{
                            marginLeft: "auto",
                            fontSize: "0.875rem",
                            color: "white",
                            textTransform: "none",
                            wordBreak: "break-word"

                        }}
                    >
                                {t("common.logout")}
                            </Button>
                        </Box>
                    </>
                )}
            </Toolbar>

            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                sx={{
                    "& .MuiDrawer-paper": {
                        backgroundColor: "primary.main",
                        color: "white",
                    },
                }}
            >
                <Box sx={{ width: 250 }}>
                    <NavigationDrawer
                        items={menu}
                        closeMenu={() => setDrawerOpen(false)} // Close drawer when menu item is clicked
                    />
                </Box>
            </Drawer>
        </AppBar>
    );
};

export default NavigationBar;
